import { calculateTotalCharges } from '../../util/Billing';
export default {
  id: 'bill.totalBillWithAddendaCharges',
  name: 'bill.totalBillWithAddendaCharges',
  displayName: 'Total with Addenda Charges ',
  valueType: 'number',
  objectType: 'bill',
  placement: {
    group: []
  },
  get: obj => {
    return calculateTotalCharges(obj);
  }
};